/** 検索欄の入力をテキスト条件とタグ条件に分解した結果。 */
export interface ParsedSearchQuery {
  text: string;
  tags: string[];
}

/**
 * 検索欄の入力文字列を解析する。
 * `#タグ` トークンはタグ条件として取り出し、それ以外は空白区切りで連結して text に入れる。
 * 空タグ（"#" 単体）は無視し、タグは初出順で重複除去する。
 */
export function parseSearchQuery(input: string): ParsedSearchQuery {
  const tokens = input.split(/[\s　]+/).filter((t) => t.length > 0);
  const textTokens: string[] = [];
  const tagSet = new Set<string>();

  for (const token of tokens) {
    if (token.startsWith('#')) {
      const tag = token.slice(1);
      if (tag.length > 0) tagSet.add(tag);
    } else {
      textTokens.push(token);
    }
  }

  return { text: textTokens.join(' '), tags: Array.from(tagSet) };
}

/** アニメーションが検索条件（テキスト・タグ AND）に一致するか判定する。 */
export function matchAnimation(
  anim: { title: string; author: string; tags: string[] },
  query: ParsedSearchQuery
): boolean {
  const matchesText =
    !query.text ||
    anim.title.toLowerCase().includes(query.text.toLowerCase()) ||
    anim.author.toLowerCase().includes(query.text.toLowerCase());
  const matchesTags = query.tags.every((tag) => anim.tags.includes(tag));
  return matchesText && matchesTags;
}
